import React from 'react';
import { Alert, Stack, Typography } from '@mui/material';
import {
  esClienteSuspendido,
  normalizarNotasCliente,
  severidadAlertaClienteSuspendido,
  textoAlertaClienteSuspendido,
  type BloqueoClienteSuspendidoModo,
} from '../../../utils/clienteEstadoFacturacion';
import { labelTipoCliente } from '../../../config/tipoClienteOptions';

interface Props {
  tipoCliente?: string | null;
  notas?: string | null;
  bloqueoModo?: BloqueoClienteSuspendidoModo;
}

const ClienteFacturacionAvisos: React.FC<Props> = ({
  tipoCliente,
  notas,
  bloqueoModo = 'alert',
}) => {
  const suspendido = esClienteSuspendido(tipoCliente);
  const notasTexto = normalizarNotasCliente(notas);

  if (!suspendido && !notasTexto) return null;

  return (
    <Stack spacing={1} sx={{ mt: 1.25 }}>
      {suspendido ? (
        <Alert
          severity={severidadAlertaClienteSuspendido(bloqueoModo)}
          variant="outlined"
          sx={{ py: 0.5 }}
        >
          Cliente en estado <strong>{labelTipoCliente(tipoCliente)}</strong>.
          {' '}
          {textoAlertaClienteSuspendido(bloqueoModo)}
        </Alert>
      ) : null}
      {notasTexto ? (
        <Alert severity="info" variant="outlined" sx={{ py: 0.5, alignItems: 'flex-start' }}>
          <Typography variant="caption" component="div" color="text.secondary" sx={{ mb: 0.25 }}>
            Notas del cliente
          </Typography>
          <Typography
            variant="body2"
            component="div"
            sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
          >
            {notasTexto}
          </Typography>
        </Alert>
      ) : null}
    </Stack>
  );
};

export default ClienteFacturacionAvisos;
